import { departmentFilter } from 'containers/Pages/People/Personnel/Layouts/options';

export const filters = (userAssignedDepartments = []) => {
  const departmentFilterField = departmentFilter(userAssignedDepartments);
  return {
    RegularFilters: [
      {
        label: 'Archived',
        field: 'archived',
        type: 'toggle',
      },
    ],
    AdvancedFilters: [...departmentFilterField],
  };
};
